export const getUniqueKeys = (data) => {
    const keys = [];
    data.forEach((item) => {
        Object.keys(item).forEach((key) => {
            if (!keys.includes(key)) {
                keys.push(key);
            }
        });
    });
    return keys;
};

export const getUniqueValues = (data, key) => {
    const values = [];
    data.forEach((item) => {
        if (!values.includes(item[key])) {
            values.push(item[key]);
        }
    });
    return values;
};



export const subsetData = (data, subsetValues, key) => {
    const subset = [];
    data.forEach((item) => {
        if (item[key]  == subsetValues) {
            subset.push(item);
        }
    });
    return subset;
};


export const parseData = (rawdata) => {
    return JSON.parse(JSON.stringify(rawdata).replace(/\s(?=\w+":)/g, ""));
};

export const calculateCriticalValues = (data, key) => {
    const values = [];
    data.forEach((item) => {
        values.push(item[key]);
    });
    const min = Math.min(...values);
    const max = Math.max(...values);
    const mean = values.reduce((a, b) => a + b) / values.length;
    const median = values.sort((a, b) => a - b)[Math.floor(values.length / 2)];
    return { min, max, mean, median };
};

export const calculateCriticalValuesPerItem = (data,  key) => {
    const values = [];
    

};